import { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { groupArrayToObjectByKey } from '@util/array-util'

import type { GeblokkeerdeWeek } from '../types/GeblokkeerdeWeek'

import { GebiedPlanningByYear } from './GebiedPlanningByYear'

export { PlanningByGebied }

type Props = {
  planning: GeblokkeerdeWeek[]
  onRemove: (geblokkeerdeWeek: GeblokkeerdeWeek) => void
}

const PlanningByGebied = ({ planning, onRemove }: Props) => {
  const planningByGebiedscodeLabel = groupArrayToObjectByKey(
    'gebiedscodeLabel',
    planning,
  )

  const baseExpanded: Record<string, boolean> = Object.fromEntries(
    Object.keys(planningByGebiedscodeLabel).map((key) => [key, true]),
  )

  const [expanded, setExpanded] = useState(baseExpanded)

  return (
    <Box>
      {Object.entries(planningByGebiedscodeLabel).map(
        ([gebiedscodeLabel, weken]) => (
          <Accordion
            key={gebiedscodeLabel}
            expanded={expanded[gebiedscodeLabel]}
            slotProps={{
              transition: {
                unmountOnExit: true,
              },
            }}
            onChange={(_, isExpanded) => {
              setExpanded({
                ...expanded,
                [gebiedscodeLabel]: isExpanded,
              })
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{gebiedscodeLabel}</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <GebiedPlanningByYear planning={weken} onRemove={onRemove} />
            </AccordionDetails>
          </Accordion>
        ),
      )}
    </Box>
  )
}
